/* eslint-disable no-param-reassign */
const GTM = require('../datalayer');
const gtmUtils = require('../utils');

const getPdpItemList = () => {
    const previousUrl = document.referrer.slice(-1) === '/' ? document.referrer.slice(0, -1) : document.referrer;
    const urlLastPart = previousUrl.substring(previousUrl.lastIndexOf('/') + 1);
    const isSearchUrl = urlLastPart.startsWith('search?');
    const textPDPList = previousUrl.substring(previousUrl.lastIndexOf('?') + 1).split('&').length > 1
        ? previousUrl.substring(previousUrl.lastIndexOf('?') + 1).split('&')[0].replace(/\+/g, ' ').replace(/-/g, ' ').replace('q=', '').replace('.html', '')
        : urlLastPart.replace(/\+/g, ' ').replace(/-/g, ' ').replace('q=', '').replace('.html', '');
    let pdpItemList = '';

    if (isSearchUrl) {
        pdpItemList = `search: ${textPDPList}`;
    } else {
        pdpItemList = textPDPList;
    }

    return pdpItemList;
};

const selectOptionClicked = () => {
    let selectedOption = {};
    if ($('.custom-select').length) {
        $('body').on('change', 'select', (e) => {
            if ($(e.target).attr('id') !== 'state') {
                const targetLabel = $(e.target).parent().find('label')[0] ? $(e.target).parent().find('label')[0].innerText : '';
                selectedOption = {
                    elementTarget: $(e.currentTarget)[0].selectedOptions[0].outerHTML,
                    labelText: targetLabel,
                };

                GTM.trackEventOption('click', selectedOption);
            }
        });
    }
};

const infoAddToCart = () => {
    $('body').on(
        'click',
        'button.add-to-cart, button.add-to-cart-global, button.add-to-cart-globalGrid',
        (e) => {
            const target = $(e.currentTarget);
            const productId = target.closest('.product-detail:not(.product-detail-set)')
                .find('.product-id')
                .text();
            const data = JSON.parse($('.prodviewData').val());

            if (!target.hasClass('disabled')) {
                const cartInfo = {
                    currency: data.mainProduct.currency,
                    product: data.mainProduct.product,
                    mainProduct: data.mainProduct.mainProduct,
                };
                // eslint-disable-next-line prefer-const
                let productToAdd = [];

                if (cartInfo.mainProduct.groupProductsId === productId
                        || cartInfo.product.item_variant) {
                    // will add only one product
                    const isProductVariation = 'item_sku' in cartInfo.product;
                    const prodIDtoCompare = isProductVariation
                        ? cartInfo.product.item_sku : cartInfo.product.item_id;

                    if (prodIDtoCompare === productId) {
                        if (isProductVariation) {
                            cartInfo.product.item_id = cartInfo.product.item_sku;
                            delete cartInfo.product.item_sku;
                        }

                        productToAdd.push(cartInfo.product);

                        if ('index' in cartInfo.product) {
                            delete productToAdd[0].index;
                        }

                        productToAdd[0].quantity = $('.quantity')
                            .eq(0)
                            .val();
                    }
                } else {
                    // will add a group of products (product set or bundle)
                    // eslint-disable-next-line no-lonely-if
                    if (typeof cartInfo.product === 'object') {
                        productToAdd = cartInfo.product;
                        productToAdd.quantity = $(
                            '.quantity',
                        ).val();
                    } else {
                        cartInfo.product.forEach((product) => {
                            cartInfo.mainProduct.mainProductsId.forEach(
                                (groupId, index) => {
                                    // eslint-disable-next-line no-undef
                                    if (product.id === groupId) {
                                        productToAdd.push(product);
                                        delete productToAdd[index].position;
                                        productToAdd[index].quantity = $(
                                            '.quantity',
                                        ).val();
                                    }
                                },
                            );
                        });
                    }
                }

                GTM.trackAddProductToCart(productToAdd);
            }
        },
    );
};

const infoProductsReady = () => {
    const data = JSON.parse($('.prodviewData').val());

    if (data) {
        const prodInfo = data.mainProduct.product;

        if ('discount' in data.mainProduct.product) {
            data.mainProduct.product.discount = parseFloat(data.mainProduct.product.discount
                .toString()
                .replace(',', '.'));
        }

        if ('coupon' in data.mainProduct.product) {
            delete data.mainProduct.product.coupon;
        }

        prodInfo.item_list_name = getPdpItemList();

        GTM.trackProductDetail(prodInfo);
    }
};

const productClicked = () => {
    const product = [];

    $('body').on(
        'click',
        '.product-tile > .image-container > a:not(.wishlistTile):not(.quickview), .product-tile > .tile-body > .pdp-link > a.product-name',
        (e) => {
            e.preventDefault();
            const productDiv = $($(e.currentTarget).parents('.product'));
            const productUrl = productDiv.find('.pdp-link > a')[0].href;

            product.push(gtmUtils.productClickStructure(productDiv));

            GTM.trackClickedProduct(product, productUrl);
        },
    );
};

const updateProdVariation = () => {
    $('body').on('seo:updateProductVariant', (e, responseProduct) => {
        const productObectDatalayer = $('.prodviewData');

        // update datalayer of input hidden (Ex:used for add to card actions)
        if (productObectDatalayer.length && productObectDatalayer.val() !== 'null') {
            const ismlDatalayerObj = JSON.parse(productObectDatalayer.val());
            // eslint-disable-next-line max-len
            ismlDatalayerObj.mainProduct.product.item_variant = responseProduct.item_variant;
            ismlDatalayerObj.mainProduct.product.price = responseProduct.price;
            ismlDatalayerObj.mainProduct.product.item_name = responseProduct.item_name;

            if ('discount' in responseProduct) {
                ismlDatalayerObj.mainProduct.product.discount = parseFloat(
                    responseProduct.discount,
                );
            } else {
                ismlDatalayerObj.mainProduct.product.discount = 0;
            }

            if (
                (responseProduct.item_id
                    !== ismlDatalayerObj.mainProduct.product.item_id
                ) && (responseProduct.item_variant !== '')
            ) {
                // eslint-disable-next-line max-len
                ismlDatalayerObj.mainProduct.product.item_sku = responseProduct.item_id;
            }

            ismlDatalayerObj.mainProduct.product.item_list_name = getPdpItemList();

            $('.prodviewData').val(JSON.stringify(ismlDatalayerObj));

            // trigger for update datalayer variation
            GTM.updateTrackProductDetail(ismlDatalayerObj.mainProduct.product);
        }
    });
};

module.exports = () => {
    selectOptionClicked();
    infoAddToCart();
    infoProductsReady();
    productClicked();
    updateProdVariation();
};
